/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PrivateImport } from './routes/private'
import { Route as AboutImport } from './routes/about'
import { Route as IndexImport } from './routes/index'
import { Route as ViabilityStorageTimeImport } from './routes/viability/storage-time'
import { Route as ViabilityMoistureEquilibriumImport } from './routes/viability/moisture-equilibrium'
import { Route as ViabilityLoseOneProbitDaysImport } from './routes/viability/lose-one-probit-days'
import { Route as SpeciesUuidImport } from './routes/species/$uuid'
import { Route as DefinitionsStorageImport } from './routes/definitions/storage'
import { Route as DefinitionsSeedWeightsImport } from './routes/definitions/seed-weights'
import { Route as DefinitionsMorphologyImport } from './routes/definitions/morphology'
import { Route as DefinitionsGerminationImport } from './routes/definitions/germination'
import { Route as DefinitionsDispersalImport } from './routes/definitions/dispersal'
import { Route as AuthSetPasswordImport } from './routes/auth/set-password'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AuthConfirmSignupImport } from './routes/auth/confirm-signup'
import { Route as PrivateUploadIndexImport } from './routes/private/upload/index'

// Create Virtual Routes

const ViabilityFinalViabilityLazyImport = createFileRoute(
  '/viability/final-viability',
)()

// Create/Update Routes

const PrivateRoute = PrivateImport.update({
  id: '/private',
  path: '/private',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ViabilityFinalViabilityLazyRoute =
  ViabilityFinalViabilityLazyImport.update({
    id: '/viability/final-viability',
    path: '/viability/final-viability',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/viability/final-viability.lazy').then((d) => d.Route),
  )

const ViabilityStorageTimeRoute = ViabilityStorageTimeImport.update({
  id: '/viability/storage-time',
  path: '/viability/storage-time',
  getParentRoute: () => rootRoute,
} as any)

const ViabilityMoistureEquilibriumRoute =
  ViabilityMoistureEquilibriumImport.update({
    id: '/viability/moisture-equilibrium',
    path: '/viability/moisture-equilibrium',
    getParentRoute: () => rootRoute,
  } as any)

const ViabilityLoseOneProbitDaysRoute = ViabilityLoseOneProbitDaysImport.update(
  {
    id: '/viability/lose-one-probit-days',
    path: '/viability/lose-one-probit-days',
    getParentRoute: () => rootRoute,
  } as any,
)

const SpeciesUuidRoute = SpeciesUuidImport.update({
  id: '/species/$uuid',
  path: '/species/$uuid',
  getParentRoute: () => rootRoute,
} as any)

const DefinitionsStorageRoute = DefinitionsStorageImport.update({
  id: '/definitions/storage',
  path: '/definitions/storage',
  getParentRoute: () => rootRoute,
} as any)

const DefinitionsSeedWeightsRoute = DefinitionsSeedWeightsImport.update({
  id: '/definitions/seed-weights',
  path: '/definitions/seed-weights',
  getParentRoute: () => rootRoute,
} as any)

const DefinitionsMorphologyRoute = DefinitionsMorphologyImport.update({
  id: '/definitions/morphology',
  path: '/definitions/morphology',
  getParentRoute: () => rootRoute,
} as any)

const DefinitionsGerminationRoute = DefinitionsGerminationImport.update({
  id: '/definitions/germination',
  path: '/definitions/germination',
  getParentRoute: () => rootRoute,
} as any)

const DefinitionsDispersalRoute = DefinitionsDispersalImport.update({
  id: '/definitions/dispersal',
  path: '/definitions/dispersal',
  getParentRoute: () => rootRoute,
} as any)

const AuthSetPasswordRoute = AuthSetPasswordImport.update({
  id: '/auth/set-password',
  path: '/auth/set-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthConfirmSignupRoute = AuthConfirmSignupImport.update({
  id: '/auth/confirm-signup',
  path: '/auth/confirm-signup',
  getParentRoute: () => rootRoute,
} as any)

const PrivateUploadIndexRoute = PrivateUploadIndexImport.update({
  id: '/upload/',
  path: '/upload/',
  getParentRoute: () => PrivateRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/private': {
      id: '/private'
      path: '/private'
      fullPath: '/private'
      preLoaderRoute: typeof PrivateImport
      parentRoute: typeof rootRoute
    }
    '/auth/confirm-signup': {
      id: '/auth/confirm-signup'
      path: '/auth/confirm-signup'
      fullPath: '/auth/confirm-signup'
      preLoaderRoute: typeof AuthConfirmSignupImport
      parentRoute: typeof rootRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/auth/set-password': {
      id: '/auth/set-password'
      path: '/auth/set-password'
      fullPath: '/auth/set-password'
      preLoaderRoute: typeof AuthSetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/definitions/dispersal': {
      id: '/definitions/dispersal'
      path: '/definitions/dispersal'
      fullPath: '/definitions/dispersal'
      preLoaderRoute: typeof DefinitionsDispersalImport
      parentRoute: typeof rootRoute
    }
    '/definitions/germination': {
      id: '/definitions/germination'
      path: '/definitions/germination'
      fullPath: '/definitions/germination'
      preLoaderRoute: typeof DefinitionsGerminationImport
      parentRoute: typeof rootRoute
    }
    '/definitions/morphology': {
      id: '/definitions/morphology'
      path: '/definitions/morphology'
      fullPath: '/definitions/morphology'
      preLoaderRoute: typeof DefinitionsMorphologyImport
      parentRoute: typeof rootRoute
    }
    '/definitions/seed-weights': {
      id: '/definitions/seed-weights'
      path: '/definitions/seed-weights'
      fullPath: '/definitions/seed-weights'
      preLoaderRoute: typeof DefinitionsSeedWeightsImport
      parentRoute: typeof rootRoute
    }
    '/definitions/storage': {
      id: '/definitions/storage'
      path: '/definitions/storage'
      fullPath: '/definitions/storage'
      preLoaderRoute: typeof DefinitionsStorageImport
      parentRoute: typeof rootRoute
    }
    '/species/$uuid': {
      id: '/species/$uuid'
      path: '/species/$uuid'
      fullPath: '/species/$uuid'
      preLoaderRoute: typeof SpeciesUuidImport
      parentRoute: typeof rootRoute
    }
    '/viability/lose-one-probit-days': {
      id: '/viability/lose-one-probit-days'
      path: '/viability/lose-one-probit-days'
      fullPath: '/viability/lose-one-probit-days'
      preLoaderRoute: typeof ViabilityLoseOneProbitDaysImport
      parentRoute: typeof rootRoute
    }
    '/viability/moisture-equilibrium': {
      id: '/viability/moisture-equilibrium'
      path: '/viability/moisture-equilibrium'
      fullPath: '/viability/moisture-equilibrium'
      preLoaderRoute: typeof ViabilityMoistureEquilibriumImport
      parentRoute: typeof rootRoute
    }
    '/viability/storage-time': {
      id: '/viability/storage-time'
      path: '/viability/storage-time'
      fullPath: '/viability/storage-time'
      preLoaderRoute: typeof ViabilityStorageTimeImport
      parentRoute: typeof rootRoute
    }
    '/viability/final-viability': {
      id: '/viability/final-viability'
      path: '/viability/final-viability'
      fullPath: '/viability/final-viability'
      preLoaderRoute: typeof ViabilityFinalViabilityLazyImport
      parentRoute: typeof rootRoute
    }
    '/private/upload/': {
      id: '/private/upload/'
      path: '/upload'
      fullPath: '/private/upload'
      preLoaderRoute: typeof PrivateUploadIndexImport
      parentRoute: typeof PrivateImport
    }
  }
}

// Create and export the route tree

interface PrivateRouteChildren {
  PrivateUploadIndexRoute: typeof PrivateUploadIndexRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateUploadIndexRoute: PrivateUploadIndexRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/private': typeof PrivateRouteWithChildren
  '/auth/confirm-signup': typeof AuthConfirmSignupRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/set-password': typeof AuthSetPasswordRoute
  '/definitions/dispersal': typeof DefinitionsDispersalRoute
  '/definitions/germination': typeof DefinitionsGerminationRoute
  '/definitions/morphology': typeof DefinitionsMorphologyRoute
  '/definitions/seed-weights': typeof DefinitionsSeedWeightsRoute
  '/definitions/storage': typeof DefinitionsStorageRoute
  '/species/$uuid': typeof SpeciesUuidRoute
  '/viability/lose-one-probit-days': typeof ViabilityLoseOneProbitDaysRoute
  '/viability/moisture-equilibrium': typeof ViabilityMoistureEquilibriumRoute
  '/viability/storage-time': typeof ViabilityStorageTimeRoute
  '/viability/final-viability': typeof ViabilityFinalViabilityLazyRoute
  '/private/upload': typeof PrivateUploadIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/private': typeof PrivateRouteWithChildren
  '/auth/confirm-signup': typeof AuthConfirmSignupRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/set-password': typeof AuthSetPasswordRoute
  '/definitions/dispersal': typeof DefinitionsDispersalRoute
  '/definitions/germination': typeof DefinitionsGerminationRoute
  '/definitions/morphology': typeof DefinitionsMorphologyRoute
  '/definitions/seed-weights': typeof DefinitionsSeedWeightsRoute
  '/definitions/storage': typeof DefinitionsStorageRoute
  '/species/$uuid': typeof SpeciesUuidRoute
  '/viability/lose-one-probit-days': typeof ViabilityLoseOneProbitDaysRoute
  '/viability/moisture-equilibrium': typeof ViabilityMoistureEquilibriumRoute
  '/viability/storage-time': typeof ViabilityStorageTimeRoute
  '/viability/final-viability': typeof ViabilityFinalViabilityLazyRoute
  '/private/upload': typeof PrivateUploadIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/private': typeof PrivateRouteWithChildren
  '/auth/confirm-signup': typeof AuthConfirmSignupRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/set-password': typeof AuthSetPasswordRoute
  '/definitions/dispersal': typeof DefinitionsDispersalRoute
  '/definitions/germination': typeof DefinitionsGerminationRoute
  '/definitions/morphology': typeof DefinitionsMorphologyRoute
  '/definitions/seed-weights': typeof DefinitionsSeedWeightsRoute
  '/definitions/storage': typeof DefinitionsStorageRoute
  '/species/$uuid': typeof SpeciesUuidRoute
  '/viability/lose-one-probit-days': typeof ViabilityLoseOneProbitDaysRoute
  '/viability/moisture-equilibrium': typeof ViabilityMoistureEquilibriumRoute
  '/viability/storage-time': typeof ViabilityStorageTimeRoute
  '/viability/final-viability': typeof ViabilityFinalViabilityLazyRoute
  '/private/upload/': typeof PrivateUploadIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/private'
    | '/auth/confirm-signup'
    | '/auth/login'
    | '/auth/set-password'
    | '/definitions/dispersal'
    | '/definitions/germination'
    | '/definitions/morphology'
    | '/definitions/seed-weights'
    | '/definitions/storage'
    | '/species/$uuid'
    | '/viability/lose-one-probit-days'
    | '/viability/moisture-equilibrium'
    | '/viability/storage-time'
    | '/viability/final-viability'
    | '/private/upload'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/private'
    | '/auth/confirm-signup'
    | '/auth/login'
    | '/auth/set-password'
    | '/definitions/dispersal'
    | '/definitions/germination'
    | '/definitions/morphology'
    | '/definitions/seed-weights'
    | '/definitions/storage'
    | '/species/$uuid'
    | '/viability/lose-one-probit-days'
    | '/viability/moisture-equilibrium'
    | '/viability/storage-time'
    | '/viability/final-viability'
    | '/private/upload'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/private'
    | '/auth/confirm-signup'
    | '/auth/login'
    | '/auth/set-password'
    | '/definitions/dispersal'
    | '/definitions/germination'
    | '/definitions/morphology'
    | '/definitions/seed-weights'
    | '/definitions/storage'
    | '/species/$uuid'
    | '/viability/lose-one-probit-days'
    | '/viability/moisture-equilibrium'
    | '/viability/storage-time'
    | '/viability/final-viability'
    | '/private/upload/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  PrivateRoute: typeof PrivateRouteWithChildren
  AuthConfirmSignupRoute: typeof AuthConfirmSignupRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
  DefinitionsDispersalRoute: typeof DefinitionsDispersalRoute
  DefinitionsGerminationRoute: typeof DefinitionsGerminationRoute
  DefinitionsMorphologyRoute: typeof DefinitionsMorphologyRoute
  DefinitionsSeedWeightsRoute: typeof DefinitionsSeedWeightsRoute
  DefinitionsStorageRoute: typeof DefinitionsStorageRoute
  SpeciesUuidRoute: typeof SpeciesUuidRoute
  ViabilityLoseOneProbitDaysRoute: typeof ViabilityLoseOneProbitDaysRoute
  ViabilityMoistureEquilibriumRoute: typeof ViabilityMoistureEquilibriumRoute
  ViabilityStorageTimeRoute: typeof ViabilityStorageTimeRoute
  ViabilityFinalViabilityLazyRoute: typeof ViabilityFinalViabilityLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  PrivateRoute: PrivateRouteWithChildren,
  AuthConfirmSignupRoute: AuthConfirmSignupRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
  DefinitionsDispersalRoute: DefinitionsDispersalRoute,
  DefinitionsGerminationRoute: DefinitionsGerminationRoute,
  DefinitionsMorphologyRoute: DefinitionsMorphologyRoute,
  DefinitionsSeedWeightsRoute: DefinitionsSeedWeightsRoute,
  DefinitionsStorageRoute: DefinitionsStorageRoute,
  SpeciesUuidRoute: SpeciesUuidRoute,
  ViabilityLoseOneProbitDaysRoute: ViabilityLoseOneProbitDaysRoute,
  ViabilityMoistureEquilibriumRoute: ViabilityMoistureEquilibriumRoute,
  ViabilityStorageTimeRoute: ViabilityStorageTimeRoute,
  ViabilityFinalViabilityLazyRoute: ViabilityFinalViabilityLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/private",
        "/auth/confirm-signup",
        "/auth/login",
        "/auth/set-password",
        "/definitions/dispersal",
        "/definitions/germination",
        "/definitions/morphology",
        "/definitions/seed-weights",
        "/definitions/storage",
        "/species/$uuid",
        "/viability/lose-one-probit-days",
        "/viability/moisture-equilibrium",
        "/viability/storage-time",
        "/viability/final-viability"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/private": {
      "filePath": "private.ts",
      "children": [
        "/private/upload/"
      ]
    },
    "/auth/confirm-signup": {
      "filePath": "auth/confirm-signup.tsx"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/auth/set-password": {
      "filePath": "auth/set-password.tsx"
    },
    "/definitions/dispersal": {
      "filePath": "definitions/dispersal.tsx"
    },
    "/definitions/germination": {
      "filePath": "definitions/germination.tsx"
    },
    "/definitions/morphology": {
      "filePath": "definitions/morphology.tsx"
    },
    "/definitions/seed-weights": {
      "filePath": "definitions/seed-weights.tsx"
    },
    "/definitions/storage": {
      "filePath": "definitions/storage.tsx"
    },
    "/species/$uuid": {
      "filePath": "species/$uuid.tsx"
    },
    "/viability/lose-one-probit-days": {
      "filePath": "viability/lose-one-probit-days.tsx"
    },
    "/viability/moisture-equilibrium": {
      "filePath": "viability/moisture-equilibrium.tsx"
    },
    "/viability/storage-time": {
      "filePath": "viability/storage-time.tsx"
    },
    "/viability/final-viability": {
      "filePath": "viability/final-viability.lazy.tsx"
    },
    "/private/upload/": {
      "filePath": "private/upload/index.tsx",
      "parent": "/private"
    }
  }
}
ROUTE_MANIFEST_END */
